// extracted by mini-css-extract-plugin
module.exports = {"root":"CarouselGraphics_root__3SqaQ","navigationBlock":"CarouselGraphics_navigationBlock__3tc-y","navigationPoint":"CarouselGraphics_navigationPoint__y5Hbb"};